import { render, staticRenderFns } from "./contactUs.vue?vue&type=template&id=62c3a548&scoped=true"
import script from "./contactUs.vue?vue&type=script&lang=js"
export * from "./contactUs.vue?vue&type=script&lang=js"
import style0 from "./contactUs.vue?vue&type=style&index=0&id=62c3a548&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c3a548",
  null
  
)

export default component.exports